import {
    Currency,
    DeliveryStatus,
    ImageCachePaths,
    MinimalAccount,
    ScalePrice,
    SpecialPrice,
    StockStatus,
} from '@synergy/models';

import { Attribute } from './attribute';
import { WishListType } from './enums/wish-list-type';

export interface WishList {
    id: number;
    suppliers: WishListSupplier[];
    type: WishListType;
    name: string;
    updatedAt: Date | null;
    itemStatuses: WishListItemStatus[];
    isOwner?: boolean;
    infoText: string;
    isSharedWithOwnAccounts: boolean;
    isSharedWithOtherAccountUsers: boolean;
    sharedAccounts: MinimalAccount[];
    customerAccount: MinimalAccount;
}

export interface WishListSupplier {
    id: number;
    name: string;
    items: WishListItem[];
    image?: ImageCachePaths;
}

export interface WishListItem {
    id: number;
    product: WishListArticle;
    previewImage?: ImageCachePaths;
    quantity: number;
    netPrice: number;
    status: WishListItemStatus;
}

export enum WishListItemStatus {
    Available,
    Removed,
    PriceByRequest,
}

export interface WishListArticle {
    id: number;
    name: string;
    number?: string;
    globalTradeItemNumber?: string;
    contentUnit?: string;
    contentQuantity?: number;
    orderUnit: string;
    stockStatus: StockStatus;
    inventory?: number;
    deliveryStatus: DeliveryStatus;
    deliveryTimeInDays?: number;
    minimumOrderQuantity: number;
    maximumOrderQuantity?: number;
    quantityInterval?: number;
    recommendedOrderQuantity?: number;
    priceQuantity: number;
    isBestPrice: boolean;
    currency: Currency;
    mainPrice: number;
    specialPrice?: SpecialPrice;
    scalePrice?: ScalePrice;
    attributes: Attribute[];
}
